import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contentlayout',
  templateUrl: './contentlayout.component.html',
  styleUrls: ['./contentlayout.component.css']
})
export class ContentlayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
